import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Create affiliate commission */
export const createAffiliateCommission = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/affiliate-commission`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating affiliate commission:", error);
        throw error;
    }
};

/* Get all affiliate commissions */
export const getAllAffiliateCommissions = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/affiliate-commission`);
        return response.data;
    } catch (error) {
        console.error("Error fetching affiliate commissions:", error);
        throw error;
    }
};

/* Get affiliate commission by ID */
export const getAffiliateCommissionById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/affiliate-commission/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching affiliate commission with ID ${id}:`, error);
        throw error;
    }
};

/* Update affiliate commission */
export const updateAffiliateCommission = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/affiliate-commission/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating affiliate commission with ID ${id}:`, error);
        throw error;
    }
};

/* Delete affiliate commission */
export const deleteAffiliateCommission = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/affiliate-commission/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting affiliate commission with ID ${id}:`, error);
        throw error;
    }
};